<template>
  <div id="ordrestyring" class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- Cancellations -->
          <!-- <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="h4 font-weight-bold text-dark">Integrationer </div>
              </div>
            </div>
          </b-card> -->
        </b-col>
      </b-row>
    </b-container>
    <b-form>
      <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
        <b-row>
          <b-col>
            <!-- notifications in general -->
            <b-card class="border-0 p-1">

              <div class="lg-flex flex-row align-items-center justify-content-between lg-col-6 col-12 mb3">
                <div class="mb2">
                  <b-img class="mr2" src="../static/img/ordrestyring-logo.png" alt="" width="100"/>
                </div>
                <div>
                  <span class="h1">Ordrestyring.dk</span>
                  <p>Overfør dine opgaver fra Håndværker.dk direkte til din arbejdskalender hos Ordrestyring. Det giver dig overblik i hverdagen.</p>
                </div>
              </div>

              <div class="card-text pb-0">
                <div>
                  <div class="flex flex-row justify-content-start">
                    <b-col lg="6" md="12" sm="12">
                      <table class="el-table__body col-12 p0 mb2">
                        <thead class="has-gutter">
                          <tr>
                            <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">API</th>
                            <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Dato ændret</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="el-table__row">
                            <td class="el-table_1_column_1">
                              <span>{{apiData.ordrestyringapi}}</span>
                            </td>
                            <td class="el-table_1_column_1 qty">
                              <span>{{apiData.ordrestyringupdate}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <b-form class="py-2">
                        <div class="lg-flex flex-wrap col-12 p0">
                          <b-form-group id="login" label="API Key" label-for="API Key" class="lg-col-10 md-col-12 p0 pr1">
                            <b-form-input v-model="api" required class="bg-light rounded p2" autocomplete="off"></b-form-input>
                          </b-form-group>
                          <b-form-group id="gemme" label="test" label-for="API Key" class="col-2 p0 m0 white">
                            <button type="button" class="flex justify-center items-center action-button gibson h5 p2 semi-bold m0" @click="addOrdrestyring()" :disabled="sendDisabled"><span>Gem</span></button>
                          </b-form-group>
                        </div>
                      </b-form>
                    </b-col>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
export default {
  name: '',
  components: {
    Simplert
  },
  created () {
    if (localStorage.getItem('PartnerAccountingInteg') === 'false') {
      this.$router.push('/login')
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.getOrdrestyring()
  },
  data () {
    return {
      salesPerson: '',
      haaId: '',
      apiData: [],
      api: '',
      sendDisabled: false
    }
  },
  methods: {
    getOrdrestyring () {
      var data = {
        operation: 'service_getordrestyring',
        salesPerson: this.salesPerson,
        levid: this.haaId
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.apiData = res
          },
          response => {
            alert('Error in getOrdrestyring()')
          }
        )
    },
    addOrdrestyring () {
      var api = this.api
      if (api !== '') {
        var data = {
          operation: 'service_addordrestyring',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          apikeye: api
        }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.getOrdrestyring()
              this.$refs.simplert.openSimplert(obj)
              this.api = ''
              this.sendDisabled = false
            },
            response => {
              alert('Error in addOrdrestyring()')
            }
          )
        this.sendDisabled = true
      } else {
        this.$toastr('error', 'Felt kræves')
      }
    }
  }
}
</script>
<style>
  @media (max-width: 52em) {
    #ordrestyring label#gemme__BV_label_ {
        display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// ordrestyring.vue?58377534